export default {
    errMsg: 'Mock Cancel PA Failure'
}